var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReminderIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/notification-bing"
  }, /*#__PURE__*/React.createElement("g", {
    id: "notification-bing"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.5 6.94043V10.2704",
    stroke: "#FF2D2D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.5199 2.5C8.8399 2.5 5.8599 5.48 5.8599 9.16V11.26C5.8599 11.94 5.5799 12.96 5.2299 13.54L3.9599 15.66C3.1799 16.97 3.7199 18.43 5.1599 18.91C9.9399 20.5 15.1099 20.5 19.8899 18.91C21.2399 18.46 21.8199 16.88 21.0899 15.66L19.8199 13.54C19.4699 12.96 19.1899 11.93 19.1899 11.26V9.16C19.1799 5.5 16.1799 2.5 12.5199 2.5Z",
    stroke: "#FF2D2D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.8299 19.3203C15.8299 21.1503 14.3299 22.6503 12.4999 22.6503C11.5899 22.6503 10.7499 22.2703 10.1499 21.6703C9.54992 21.0703 9.16992 20.2303 9.16992 19.3203",
    stroke: "#FF2D2D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReminderIcon);
export default __webpack_public_path__ + "static/media/reminder_icon.42fbdfaaac02f6f39cdc7eef6cec2c57.svg";
export { ForwardRef as ReactComponent };